import { trackAnalyticsEvent } from '@jsmdg/tracking';

function trackLoadMoreButtonClicked(): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductSelectionBlock',
            action: 'ButtonClick',
            label: 'Load more',
        });
    }, 0);
}

export { trackLoadMoreButtonClicked };
